import axiosInstance from '../../../config/axiosInstance';
import { CommunicationValidation } from "../Views/Validation/CommunicationValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (
  event,
  formData,
  setFormData,
  setErrors,
  pdfAttachment
) => {

  const formErrors = CommunicationValidation(formData);
  setErrors(formErrors);
  debugger;
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID = localStorage.getItem("CompanyID");
      const UserID = localStorage.getItem("UserID");
      const formDataToSend = new FormData();

      formDataToSend.append('ClientID', CompanyID);
      formDataToSend.append('UserID', UserID);

      Object.keys(formData).forEach(key => {
        if (key !== 'File') {
          formDataToSend.append(key, formData[key]);
        }
      });

      const selectedFile = pdfAttachment?.file || formData.File;

      if (selectedFile instanceof File) {
        formDataToSend.append("Attachment", selectedFile);
      }

      // 🔍 Debugging

      console.log("pdfAttachment:", pdfAttachment);
      console.log("Is File:", pdfAttachment?.file instanceof File);
      debugger;

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };


      const response = await axiosInstance.post(`/Lead/CreateCoomunication`, formDataToSend, config);


      return response;

    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };